import { createGlobalStore } from 'hox';
import { useState } from 'react';

function useSiderWidth() {
  const [siderWidth, setSiderWidth] = useState(64);
  const [collapsed, setCollapsed] = useState(true);
  const setSiderCollapsed = (collapsed: boolean) => {
    setCollapsed(collapsed);
    setSiderWidth(collapsed ? 64 : 280);
  };
  return {
    siderWidth,
    collapsed,
    setSiderWidth,
    setSiderCollapsed,
  };
}

export const [useSiderWidthStore] = createGlobalStore(useSiderWidth);
